import { Bubble } from '../types';
import { IHexGridData, IPopOutSpaceData, Place } from 'js/bubbleCore/types';
import { removeFromGrid } from 'js/bubbleCore/utils/removeFromGrid';
import { gridHexToSpacePosition } from 'js/bubbleCore/utils/gridHexToSpacePosition';
import { RandomDataGenerator } from 'framework/RandomDataGenerator/RandomDataGenerator';
import { IEvent, createBubbleUpdatedEvent } from 'js/bubbleCore/events';
import { transferBubble } from 'js/bubbleCore/handlers/transferBubble';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';

export function popOutBubble(board: BubbleGameBoard, bubble: Bubble): void {
  const events = board.getEventsQueue();
  const data = board.getData();
  const rnd = board.getRDG();
  const { grid, popOutSpace } = data;

  const spacePosition = gridHexToSpacePosition(
    bubble.col,
    bubble.row,
    grid,
  );

  bubble.hexSpaceX = spacePosition.x;
  bubble.hexSpaceY = spacePosition.y;
  bubble.velX = rnd.realInRange(popOutSpace.popOutVelRange.left, popOutSpace.popOutVelRange.right);
  bubble.velY = rnd.realInRange(popOutSpace.popOutVelRange.top, popOutSpace.popOutVelRange.bottom);  

  events.push(createBubbleUpdatedEvent(bubble));
  transferBubble(bubble, data, Place.PopOutSpace, events);
}
